import { TableUserListCell } from '../../Table'
import { toUserMultiValue } from '../../User'

import { sortParticipantsMoreItems } from './ChatTableRowParticipants.utils'

function ChatTableRowParticipants({
  item,
  scrollRef,
  sortMoreItems = sortParticipantsMoreItems,
  ...restProps
}) {
  const { users } = item

  return (
    <TableUserListCell
      {...restProps}
      scrollRef={scrollRef}
      sortMoreItems={sortMoreItems}
      value={users?.map(toUserMultiValue)}
    />
  )
}

export default ChatTableRowParticipants
